import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;

export class CapacitorStore {
  async getItem(key: string) : Promise<string | null> {
    const { value } = await Storage.get({ key });
    return value;
  }

  async setItem(key: string, value: string) : Promise<void> {
    await Storage.set({ key, value })
  }

  async removeItem(key: string) : Promise<void> {
    await Storage.remove({ key })
  }
}